export default __webpack_public_path__ + "static/media/Inter-ExtraBold.1ca2a2cf.woff2";